<template>
    <b-overlay :show="getting">
        <b-card no-body>
            <div class="pt-1 px-1">
                <div class="row justify-content-end align-items-center">
                    <div class="col-md-3">
                        <b-input-group class="input-group-merge">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input placeholder="Ara..." v-model="search"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="px-1 pt-1">
                <img style="max-width: 750px;" src="@/assets/images/meal-equation.svg"/>
            </div>
            <div class="table-responsive">
                <table class="table table-sm bordered-header mt-1">
                    <thead>
                        <tr>
                            <th colspan="5"></th>
                            <th colspan="200">Organizasyonel Düzeylere Göre Yemek Ücretler (TL/GÜN)</th>
                        </tr>
                        <tr>
                            <th>Bölge</th>
                            <th>Şehir</th>
                            <th class="text-nowrap">Endeks Kategorisi</th>
                            <th class="text-right">Katsayı</th>
                            <th class="text-nowrap text-right">Yemek Ücerti (TL/Gün)</th>
                            <th v-for="(c,i) in columns" :key="i" class="text-right">{{ c }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d,i) in searched" :key="i" :style="{backgroundColor:getColor(i)}">
                            <td class="text-nowrap">{{ $safe(d,'RegionName') }}</td>
                            <td>{{ $safe(d,'ProvinceName') }}</td>
                            <td>{{ $safe(d,'ProvinceIndexCategoryName') }}</td>
                            <td class="text-right font-weight-bolder" :style="{color:getColor(i,1)}">{{ $safe(d,'MultiplierStr') }}</td>
                            <td class="text-right">{{ $safe(d,'MealPriceStr') }}</td>
                            <td v-for="(c,i) in columns" :key="i" class="text-right">
                                {{ getCellValue(d,c) }}
                            </td>
                        </tr>
                        <tr  v-if="(searched || []).length == 0" class="text-center">
                            <td colspan="1000">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { BOverlay, BCard, BInputGroupText, BInputGroup, BFormInput } from 'bootstrap-vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import additional from '@/utilities/additional';

export default {
    components:{
        BCard,
        BOverlay,
        BInputGroupText,
        BInputGroup,
        BFormInput
    },
    data(){
        return {
            getting:false,
            datas:[],
            search:''
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            this.getting = true
            HumanResourcesParameterApi.MealPricesBasedByOrganisationalLocation().then(res => {
                this.datas = res.data.Data || []
                this.getting = false
            }).catch(err => {
                this.$result(null,err)
                this.getting = false
            })
        },
        getCellValue(cell,key){
            return (cell.PricesPerLevel || []).find(s => s.Key == key)?.Value || '-'
        },
        getColor(index,alpha = 0.15) {
            const startCol = "#FF2442";  // kırmızı
            const endCol   = "#36AE7C";  // yeşil

            // Hex → {r,g,b}
            function hexToRgb(hex) {
                const h = hex.replace(/^#/, "");
                const num = parseInt(h, 16);
                return {
                r: (num >> 16) & 0xff,
                g: (num >> 8) & 0xff,
                b: num & 0xff
                };
            }

            const start = hexToRgb(startCol);
            const end   = hexToRgb(endCol);

            let ratio = index / ((this.datas || []).length || 1);
            if (ratio < 0) ratio = 0;
            if (ratio > 1) ratio = 1;

            const r = Math.round(start.r + (end.r - start.r) * ratio);
            const g = Math.round(start.g + (end.g - start.g) * ratio);
            const b = Math.round(start.b + (end.b - start.b) * ratio);

            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
    },
    computed:{
        searched(){
            return (this.datas || []).filter(s => additional.ToEng(s.ProvinceName.toLowerCase()).includes(additional.ToEng(this.search.toLowerCase())))
        },
        columns(){
            if((this.datas || []).length >= 1){
                return this.datas[0].PricesPerLevel?.map(s => s.Key) 
            }else return []
        }
    }
}
</script>